module.exports = __webpack_public_path__ + "static/img/cus_17_pre.93f69a8a.jpg";